import { HTMLAttributes } from 'react';

export type IconProps = HTMLAttributes<SVGElement>;
